import { ApolloLink } from 'apollo-link'
import { TransactionHeaderName } from '@/store/modules/Transaction'

export function transactionHeaderLink (vueStore) {
  return new ApolloLink((operation, forward) => {
    if (operation.operationName) {
      const token = vueStore.getters['Transaction/transactionIds'][operation.operationName]

      if (token) {
        operation.setContext((context) => {
          context.headers[TransactionHeaderName] = `${token}`
        })
      }
    }

    return forward(operation)
  })
}
